import { render, staticRenderFns } from "./gongpgx.vue?vue&type=template&id=7308c311&scoped=true&"
import script from "./gongpgx.vue?vue&type=script&lang=js&"
export * from "./gongpgx.vue?vue&type=script&lang=js&"
import style0 from "./gongpgx.vue?vue&type=style&index=0&id=7308c311&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7308c311",
  null
  
)

export default component.exports